import React, { useState } from 'react';
import { Button, Tooltip } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import { useDocumentAccessRole } from 'global/hooks/useDocumentAccessRole';
import { UploadDocumentModalStore } from 'store/modules/upload-documents/ui-stores/uploadDocumentModalStore';
import { RequestDocumentModalStore } from 'store/modules/upload-documents/ui-stores/requestDocumentModalStore';
import { DocumentAccessRole } from 'types/documentsService';
import { Add } from '@insurancemenu/imenu-components-lib/dist/icons';
import { SectionStyled } from './styles';
import RequestDocumentModal from '../RequestDocumentModal';
import UploadDocumentModal from '../UploadDocumentModal';
import { REQUEST_DOCUMENT_BUTTON_TEST_ID, UPLOAD_DOCUMENT_BUTTON_TEST_ID } from '../constants';

export interface Props {
  requestDocumentModalStore: RequestDocumentModalStore | null;
  uploadDocumentModalStore: UploadDocumentModalStore | null;
  disableMutativeActions?: boolean;
  loading?: boolean;
}

const DocumentActionsSection: React.FC<Props> = observer(
  ({ requestDocumentModalStore, uploadDocumentModalStore, loading, disableMutativeActions = false }) => {
    const accessRole = useDocumentAccessRole();

    const [showAddRequiredModal, setShowAddRequiredModal] = useState(false);
    const [showUploadDocumentModal, setShowUploadDocumentModal] = useState(false);

    function openAddRequiredModal(): void {
      setShowAddRequiredModal(true);
    }

    function closeAddRequiredModal(): void {
      setShowAddRequiredModal(false);
    }

    function openUploadDocumentModal(): void {
      setShowUploadDocumentModal(true);
    }

    function closeUploadDocumentModal(): void {
      setShowUploadDocumentModal(false);
    }

    return (
      <SectionStyled>
        {disableMutativeActions ? (
          <Tooltip label="This step has been completed">
            <Button
              color="primary"
              size="large"
              width="31rem"
              onClick={openUploadDocumentModal}
              disabled
              data-test-id={UPLOAD_DOCUMENT_BUTTON_TEST_ID}
            >
              Upload Document
            </Button>
          </Tooltip>
        ) : (
          <Button
            color="primary"
            size="large"
            width="31rem"
            onClick={openUploadDocumentModal}
            disabled={loading || disableMutativeActions}
            data-test-id={UPLOAD_DOCUMENT_BUTTON_TEST_ID}
          >
            Upload Document
          </Button>
        )}
        {accessRole !== DocumentAccessRole.ER_EE && (
          <>
            {disableMutativeActions ? (
              <Tooltip label="This step has been completed">
                <Button
                  color="primary"
                  size="large"
                  width="31rem"
                  type="outlined"
                  onClick={openAddRequiredModal}
                  disabled
                  data-test-id={REQUEST_DOCUMENT_BUTTON_TEST_ID}
                  leftIconProp={<Add />}
                >
                  Request Another Document
                </Button>
              </Tooltip>
            ) : (
              <Button
                color="primary"
                size="large"
                width="31rem"
                type="outlined"
                onClick={openAddRequiredModal}
                disabled={loading || disableMutativeActions}
                data-test-id={REQUEST_DOCUMENT_BUTTON_TEST_ID}
                leftIconProp={<Add />}
              >
                Request Another Document
              </Button>
            )}
            {requestDocumentModalStore && (
              <RequestDocumentModal
                show={showAddRequiredModal}
                onClose={closeAddRequiredModal}
                modalStore={requestDocumentModalStore}
              />
            )}
          </>
        )}

        {uploadDocumentModalStore && (
          <UploadDocumentModal
            show={showUploadDocumentModal}
            onClose={closeUploadDocumentModal}
            modalStore={uploadDocumentModalStore}
          />
        )}
      </SectionStyled>
    );
  },
);

export default DocumentActionsSection;
